import React from 'react';

const SettingsCard = ({ 
  title, 
  description, 
  icon,
  children,
  className = '',
  disabled = false,
  gradient = false
}) => {
  return (
    <div className={`relative ${gradient ? 'bg-gradient-to-br from-white to-gray-50' : 'bg-white/80 backdrop-blur-sm'} border border-white/20 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 ${disabled ? 'opacity-60' : ''} ${className}`}>
      <div className="flex items-start space-x-4">
        {icon && (
          <div className="flex-shrink-0">
            <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-500 rounded-xl flex items-center justify-center shadow-lg">
              {icon}
            </div>
          </div>
        )}
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
          {description && (
            <p className="text-gray-600 text-sm mb-4 leading-relaxed">{description}</p>
          )}
          {children}
        </div>
      </div>
    </div>
  );
};

export default SettingsCard;